import React from 'react';

export const UpdateProjectTaxLotsActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} {props.CustomEventData.action} the Tax Lot
    "{props.CustomEventData ? props.CustomEventData.value : ""}".
</p>;


